import React from 'react';
import "./Demographics.css";
import MapWithDescription from '../Maps/MapWithDescription';
import Population from '../Maps/Population';
import Product from '../Maps/Product';
import  Agriculture from '../Maps/Agriculture';
import Land from '../Maps/Land';
import PopAsal from '../Maps/PopAsal';
import Nutrition from '../Maps/Nutrition';
import Nav from '../Nav';
import Navbar from '../Navbar';
import Footer from '../Footer/Footer';

function Demographics() {
  return (
    <div>
            <Nav />
            <Navbar />
     <h1 className='demo__header'>DEMOGRAPHICS</h1>
 
    <div className='demo'>
      <MapWithDescription />
        <Product />
        <Population />
  <Agriculture />
  <Land />
  <PopAsal />
  <Nutrition />
    </div>
    <div style={{marginTop: '20px'}}>
        <Footer />
    </div>
    </div>
  )
}

export default Demographics
